<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 30 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-4 w-4"
  >
    <g clip-path="url(#clip0_3821_94)">
      <mask
        id="mask0_3821_94"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="29"
      >
        <path d="M30 0H0V29H30V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3821_94)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.4207 14.5L29.2589 4.9898C29.4966 4.7621 29.6854 4.4913 29.8145 4.1928C29.9436 3.8944 30.0105 3.5743 30.0112 3.2508C30.012 2.9273 29.9466 2.6069 29.8189 2.3079C29.6912 2.0089 29.5037 1.7373 29.267 1.5086C29.0304 1.2798 28.7494 1.0985 28.4401 0.9751C28.1308 0.8517 27.7993 0.7885 27.4647 0.7892C27.1301 0.79 26.7989 0.8546 26.4902 0.9794C26.1815 1.1042 25.9013 1.2867 25.6658 1.5165L14.7192 12.0985C13.1103 13.7119 13.3227 15.5522 14.7144 16.8976L25.6656 27.4838C26.1421 27.9444 26.7885 28.2031 27.4623 28.2031C28.1362 28.2031 28.7825 27.9443 29.259 27.4837C29.7355 27.023 30.0032 26.3982 30.0032 25.7468C30.0032 25.0954 29.7355 24.4706 29.2589 24.01L19.4207 14.5ZM15.6687 24.0103C16.1452 24.4709 16.4128 25.0956 16.4128 25.7469C16.4128 26.3983 16.1452 27.023 15.6687 27.4836C15.1922 27.9442 14.546 28.2029 13.8721 28.2029C13.1983 28.2029 12.5521 27.9442 12.0756 27.4836L1.1244 16.8975C-0.2673 15.5521 -0.4797 13.7117 1.1292 12.0983L12.0756 1.5165C12.5521 1.0559 13.1983 0.7971 13.8721 0.7971C14.546 0.7971 15.1922 1.0559 15.6687 1.5165C16.1452 1.9771 16.4128 2.6018 16.4128 3.2531C16.4128 3.9045 16.1452 4.5292 15.6687 4.9898L5.8305 14.5L15.6687 24.0103Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3821_94">
        <rect width="30" height="29" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
